import toast from "./toast";

function setFromParams(type) {
  const urlParams = new URLSearchParams(window.location.search);
  const predicate = urlParams.get(type);
  if ([true, "true", false, "false"].includes(predicate)) {
    sessionStorage.setItem(type, predicate);
  }
}

function getNewUrl({ env, app }) {
  let url = `tms-backend-${env}.eks.apps.speedyfreight.com`;
  if (env === "local") {
    url = "localhost:4000";
  } else if (env === "prod") {
    url = "tms-backend.tms.speedyfreight.com";
  } else if (env === "prod-test") {
    url = "tms-backend-test.tms.speedyfreight.com";
  }

  return `${location.protocol}//${url}/${app}`;
}

function getServerTmsUrl({ app, oldUrl, env }) {
  const type = "isOldServer";
  setFromParams(type);
  const sessionPredicate = sessionStorage.getItem(type);
  const predicate = sessionPredicate === "true";

  if (predicate) {
    toast.displayToast({
      titleText: `Old Server [${app}]`,
      bodyMessageText: `You are using the old server. URL: ${oldUrl}`,
      initializeConfigObj: {
        autohide: true,
        delay: 10 * 1000 // 10 seconds
      }
    });
    return oldUrl.replace(/\/$/, "");
  }

  return getNewUrl({ env, app });
}

// Avoid calling getServerTmsUrl multiple times
let serverTmsCustomer;
let serverTmsJobBooking;

const serverCheck = {
  getServer: function () {
    const nonProdLoginUrl =
      "https://tms-sso-np.auth.eu-west-2.amazoncognito.com";
    const nonProdLoginClientId = "589u0q8eh8b3kkt4opr1qen9i4";

    const prodLoginUrl =
      "https://tms-sso-prod.auth.eu-west-2.amazoncognito.com";
    const prodLoginClientId = "1iqk04kl8d37jtu284n18ovma0";

    let env = "local";
    let serverCustomer = "";
    let serverJobBooking = "";
    let serverLoginUrl = "";
    let serverLoginClientId = "";
    let parcelsWmsUrl = "";
    let parcelsAppUrl = "";
    let customerPortalUrl = "";

    switch (window.location.origin) {
      case location.protocol + "//tms.speedyfreight.com":
        env = "prod";
        serverCustomer = `${location.protocol}//customer.tms.speedyfreight.com/`;
        serverJobBooking = `${location.protocol}//qpjb.tms.speedyfreight.com/`;
        serverLoginUrl = prodLoginUrl;
        serverLoginClientId = prodLoginClientId;
        parcelsWmsUrl = "https://wms.speedyfulfil.com/";
        parcelsAppUrl = "https://app.speedyfulfil.com/";
        customerPortalUrl = "https://my.speedyfreight.com/";
        break;

      case location.protocol + "//tms-dev.eks.apps.speedyfreight.com":
        env = "dev";
        serverCustomer = `${location.protocol}//customers-dev.eks.apps.speedyfreight.com/`;
        serverJobBooking = `${location.protocol}//qpjb-dev.eks.apps.speedyfreight.com/`;
        serverLoginUrl = nonProdLoginUrl;
        serverLoginClientId = nonProdLoginClientId;
        parcelsWmsUrl = "https://wms.dev.speedyfulfil.com/";
        parcelsAppUrl = "https://app.dev.speedyfulfil.com/";
        customerPortalUrl = "https://dev.np.my.speedyfreight.com/";
        break;

      case location.protocol + "//tms-dev-test.eks.apps.speedyfreight.com":
        env = "dev-test";
        serverCustomer = `${location.protocol}//customers-dev-test.eks.apps.speedyfreight.com/`;
        serverJobBooking = `${location.protocol}//qpjb-dev-test.eks.apps.speedyfreight.com/`;
        serverLoginUrl = nonProdLoginUrl;
        serverLoginClientId = nonProdLoginClientId;
        parcelsWmsUrl = "https://wms.dev.speedyfulfil.com/";
        parcelsAppUrl = "https://app.dev.speedyfulfil.com/";
        customerPortalUrl = "https://dev.np.my.speedyfreight.com/";
        break;

      case location.protocol + "//tms-uat.eks.apps.speedyfreight.com":
        env = "uat";
        serverCustomer = `${location.protocol}//customers-uat.eks.apps.speedyfreight.com/`;
        serverJobBooking = `${location.protocol}//qpjb-uat.eks.apps.speedyfreight.com/`;
        serverLoginUrl = nonProdLoginUrl;
        serverLoginClientId = nonProdLoginClientId;
        parcelsWmsUrl = "https://wms.uat.speedyfulfil.com/";
        parcelsAppUrl = "https://app.uat.speedyfulfil.com/";
        customerPortalUrl = "https://uat.np.my.speedyfreight.com/";
        break;

      case location.protocol + "//tms-uat-test.eks.apps.speedyfreight.com":
        env = "uat-test";
        serverCustomer = `${location.protocol}//customers-uat-test.eks.apps.speedyfreight.com/`;
        serverJobBooking = `${location.protocol}//qpjb-uat-test.eks.apps.speedyfreight.com/`;
        serverLoginUrl = nonProdLoginUrl;
        serverLoginClientId = nonProdLoginClientId;
        parcelsWmsUrl = "https://wms.uat.speedyfulfil.com/";
        parcelsAppUrl = "https://app.uat.speedyfulfil.com/";
        customerPortalUrl = "https://uat.np.my.speedyfreight.com/";
        break;

      case location.protocol + "//tms-test.tms.speedyfreight.com":
        env = "prod-test";
        serverCustomer = `${location.protocol}//customers-backend-eks-test.tms.speedyfreight.com/`;
        serverJobBooking = `${location.protocol}//qpjb-backend-eks-test.tms.speedyfreight.com/`;
        serverLoginUrl = prodLoginUrl;
        serverLoginClientId = prodLoginClientId;
        parcelsWmsUrl = "https://wms.uat.speedyfulfil.com/";
        parcelsAppUrl = "https://app.uat.speedyfulfil.com/";
        customerPortalUrl = "https://uat.np.my.speedyfreight.com/";
        break;

      default:
        serverCustomer = `${location.protocol}//${location.hostname}:3001/`;
        serverJobBooking = `${location.protocol}//${location.hostname}:3002/`;
        // This will just about always need to be set to nonProd, but can be overridden if needed
        serverLoginUrl = nonProdLoginUrl;
        serverLoginClientId = nonProdLoginClientId;
        parcelsWmsUrl = "https://wms.dev.speedyfulfil.com/";
        parcelsAppUrl = "https://app.dev.speedyfulfil.com/";
        customerPortalUrl = "https://dev.np.my.speedyfreight.com/";
    }

    const serverTmsAdmin = getNewUrl({
      env,
      app: "admin"
    });

    if (!serverTmsCustomer) {
      serverTmsCustomer = getServerTmsUrl({
        app: "customers",
        oldUrl: serverCustomer,
        env
      });
    }

    if (!serverTmsJobBooking) {
      serverTmsJobBooking = getServerTmsUrl({
        app: "qpjb",
        oldUrl: serverJobBooking,
        env
      });
    }

    return {
      serverCustomer,
      serverJobBooking,
      serverLoginUrl,
      serverLoginClientId,
      parcelsWmsUrl,
      parcelsAppUrl,
      customerPortalUrl,
      serverTmsAdmin,
      serverTmsCustomer,
      serverTmsJobBooking
    };
  }
};

export default serverCheck;
